import React, { forwardRef } from 'react';

import { StyledIcon } from '../StyledIcon';

const Navigate = forwardRef((props, ref) => (
  <StyledIcon ref={ref} viewBox="0 0 24 24" a11yTitle="Navigate" {...props}>
    <path d="M12 1C12.5523 1.00001 13 1.44772 13 2V6H20C20.3344 6.00001 20.6466 6.16712 20.8321 6.44531L22.8321 9.44531C23.056 9.78121 23.056 10.2188 22.8321 10.5547L20.8321 13.5547C20.6466 13.8329 20.3344 14 20 14H13V22H11V11H4.00003C3.66568 11 3.35347 10.8329 3.168 10.5547L1.168 7.55469C0.944067 7.21879 0.944067 6.78121 1.168 6.44531L3.168 3.44531L3.24319 3.34668C3.43178 3.12817 3.70736 3 4.00003 3H11V2C11 1.44772 11.4477 1 12 1ZM13 12H19.4649L20.7979 10L19.4649 8H13V12ZM3.2012 7L4.53519 9H11V5H4.53519L3.2012 7Z" fill="#000" />
  </StyledIcon>
));

Navigate.displayName = 'Navigate';

export { Navigate };
